/**
 * Звуковий і тактильний відгук на скановані товари.
 *
 * Касир дивиться на товар, а не в екран, тому підтвердження має бути
 * чутним. Раніше єдиним сигналом було спливаюче повідомлення — його
 * легко пропустити, і касир сканував той самий товар ще раз.
 */

let audioContext = null;

const getContext = () => {
    if (typeof window === 'undefined') {
        return null;
    }

    const AudioContextClass = window.AudioContext || window.webkitAudioContext;

    if (!AudioContextClass) {
        return null;
    }

    if (!audioContext) {
        audioContext = new AudioContextClass();
    }

    return audioContext;
};

/**
 * Короткий сигнал. Генеруємо його осцилятором, а не звуковим файлом:
 * жодного зайвого запиту, і працює офлайн.
 *
 * @param {'success'|'error'} tone
 */
export const beep = (tone = 'success') => {
    const context = getContext();

    if (!context) {
        return;
    }

    // iOS тримає контекст призупиненим, доки не буде дії користувача.
    if (context.state === 'suspended') {
        context.resume().catch(() => {});
    }

    try {
        const oscillator = context.createOscillator();
        const gain = context.createGain();

        oscillator.type = 'sine';
        oscillator.frequency.value = tone === 'error' ? 220 : 880;

        // Плавне згасання, щоб не було клацання на кінці.
        gain.gain.setValueAtTime(0.0001, context.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.2, context.currentTime + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.18);

        oscillator.connect(gain);
        gain.connect(context.destination);

        oscillator.start();
        oscillator.stop(context.currentTime + 0.2);
    } catch (error) {
        console.debug('Звуковий сигнал недоступний', error);
    }
};

/** Вібрація там, де вона є (Android; iOS Safari її не підтримує). */
export const vibrate = (pattern = 40) => {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
        navigator.vibrate(pattern);
    }
};

/** Товар успішно розпізнано й додано. */
export const signalSuccess = () => {
    beep('success');
    vibrate(40);
};

/** Код прочитано, але товару за ним немає. */
export const signalFailure = () => {
    beep('error');
    vibrate([40, 60, 40]);
};
